/* nt-fx-pag-c.js: barras de tempo sem drift do "qual escolher" (estilo novo).
   as barras crescem quando o painel entra na tela; sem js elas ja nascem cheias (css). */
(function () {
  function iniciar() {
    var paineis = document.querySelectorAll('[data-qual-drift]:not(.is-in)');
    if (!paineis.length) return;
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduz || !('IntersectionObserver' in window)) {
      paineis.forEach(function (p) { p.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -80px 0px' });
    paineis.forEach(function (p) { io.observe(p); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
